import { Menu, Monitor, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Link } from './Link';
import { ThemeToggle } from './ThemeToggle';

export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const pathname = window.location.pathname;

  useEffect(() => {
    if (!menuOpen) return;
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setMenuOpen(false);
    };
    window.addEventListener('keydown', closeOnEscape);
    return () => window.removeEventListener('keydown', closeOnEscape);
  }, [menuOpen]);

  return (
    <header className="site-header">
      <div className="header-inner">
        <Link className="brand" href="/" aria-label="Retro Profiles home" onClick={() => setMenuOpen(false)}>
          <span className="brand-mark" aria-hidden="true"><Monitor size={22} /></span>
          <span className="brand-wordmark"><strong>Retro</strong> Profiles</span>
        </Link>
        <button className="icon-button menu-button" type="button" onClick={() => setMenuOpen((value) => !value)} aria-expanded={menuOpen} aria-controls="primary-navigation" aria-label="Toggle navigation">
          {menuOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
        <nav id="primary-navigation" className={menuOpen ? 'primary-nav is-open' : 'primary-nav'} aria-label="Primary navigation">
          <Link href="/search" aria-current={pathname === '/search' ? 'page' : undefined} onClick={() => setMenuOpen(false)}>Browse Profiles</Link>
          <Link href="/packs" aria-current={pathname.startsWith('/packs') ? 'page' : undefined} onClick={() => setMenuOpen(false)}>Profile Packs</Link>
        </nav>
        <ThemeToggle />
      </div>
    </header>
  );
}
